import React from 'react';
import { addCommunityForum } from '../../api/apiHandler';
import { useTranslation } from 'react-i18next';
import '../../i18'; 

export const CommunityForumModal = ({isOpen, isClose, setSubmitQuery, setPageToken, setSelectedForumPageToken, setSearchedForumList}) => {
    const { t } = useTranslation();
    if (!isOpen) return null;

    const handleQuerySubmit = () => {
        const input  = document.getElementById("query-inp");
        const value = input.value.trim();
        if(value !== ''){
            const addQuery = async () => {
                try{
                    const response = await addCommunityForum({
                        query: value
                    });
                    if (response.code === 200) {
                        setSubmitQuery(value);
                        setPageToken(1);
                        setSelectedForumPageToken(1);
                        setSearchedForumList([]);
                        isClose();
                    }
                }
                catch(err){
                    console.log('err: ', err);
                }
            }
            addQuery();
        }
    }

    return (
        <div className="PostCommunityForumModal modal-overlay">
            <div className="modal show" id="PostCommunityForumModal" tabIndex="-1" aria-hidden={!isOpen} style={{ display: 'block' }}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5">
                                {t('communityForumHeading')}
                            </h1>
                            <button 
                                type="button" 
                                className="btn-close" 
                                onClick={isClose} // Close the modal when the button is clicked
                                aria-label="Close">
                            </button>
                        </div>
                        <div className="modal-body">
                            {/* <form action="#"> */}
                                <div className="single-input-inner style-bg-border m-0">
                                    <textarea name="" id="query-inp" 
                                        style={{resize: 'none'}}
                                    ></textarea>
                                </div>
                            {/* </form> */}
                        </div>
                        <div className="modal-footer d-flex justify-content-center gap-4 border-0">
                            <button 
                                type="button" 
                                className="btn btn-border-black b-animate-3" 
                                onClick={isClose}>  {/* Close the modal */}
                                {t('cancel')}
                            </button>
                            <a href="javascript:void(0)" className="btn btn-base b-animate-3 ConfirmTestResults" data-bs-dismiss="modal" onClick={handleQuerySubmit}>
                                {t('post')}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
